import { SequenceManagerAction } from '../actions/SequenceManagerAction';
import { mapDeliveryCheck, deliverySendOtp, deliveryValidateOtp, rSendOtp } from "../api/api";

const DeliveryDetailsAction = {
    DELIVERY_DETAILS_SUCCESS: 'DELIVERY_DETAILS_SUCCESS',
    DELIVERY_CHECK_SUCCESS: 'DELIVERY_CHECK_SUCCESS',
    DELIVERY_OTP_INITIATE_SUCCESS: 'DELIVERY_OTP_INITIATE_SUCCESS',
    DELIVERY_OTP_VALIDATE_SUCCESS: 'DELIVERY_OTP_VALIDATE_SUCCESS',
    DELIVERY_OTP_RSEND_SUCCESS: 'DELIVERY_OTP_RSEND_SUCCESS',
}


const getDeliveryDetails = (email: any, name: any, phone: any, contactPhone: any, address: any, notes: any, currLoc: any, nationalAddress: any, natPostalCode: any, natPoBox: any, nationalCityName: any, nationalName: any, natId: any, isConsentBoxChecked: any) => {
    return function (dispatch: any) {
        dispatch({ type: DeliveryDetailsAction.DELIVERY_DETAILS_SUCCESS, payload: { email: email, name: name, phone: phone, contactPhone: contactPhone, address: address, notes: notes, currLoc: currLoc, nationalAddress: nationalAddress, natPostalCode: natPostalCode, natPoBox: natPoBox, nationalCityName: nationalCityName, nationalName: nationalName, natId: natId, isConsentBoxChecked: isConsentBoxChecked } });
        dispatch({ type: SequenceManagerAction.SECTION_COMPLETE, payload: ['DeliveryDetails'] });
    }
}

const deliveryCheck = (lat: any, lng: any, city: any) => {
    return function (dispatch: any) {
        mapDeliveryCheck(lat, lng, city)
            .then((response: any) => {
                dispatch({ type: DeliveryDetailsAction.DELIVERY_CHECK_SUCCESS, payload: { response: response?.data, lat: lat, lng: lng } });
            })
            .catch((error) => {
                //Display error
                if (error?.response) {
                    dispatch({ type: DeliveryDetailsAction.DELIVERY_CHECK_SUCCESS, payload: { response: error?.response, lat: lat, lng: lng } });
                } else {
                    dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
                }
            })
    }

}

const OTPInitiate = (phoneNumber: any, modId: any, lang: any, otpLength: any, isNumeric: any) => {
    return function (dispatch: any) {
        deliverySendOtp(phoneNumber, modId, lang, otpLength, isNumeric)
            .then((response) => {
                dispatch({ type: DeliveryDetailsAction.DELIVERY_OTP_INITIATE_SUCCESS, payload: response });
            })
            .catch((err) => {
                //Display error
                const config = Object.assign(err?.config, { serviceName: 'sendCEMOTP' });
                const error = { ...err, config }

                dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
            })
    }
}

const OTPValidateApi = (otp: any, hashCode: any) => {
    return function (dispatch: any) {
        deliveryValidateOtp(otp, hashCode)
            .then((response) => {
                dispatch({ type: DeliveryDetailsAction.DELIVERY_OTP_VALIDATE_SUCCESS, payload: response });
            })
            .catch((err) => {
                //Display error
                const config = Object.assign(err?.config, { serviceName: 'validateCEMOTP' });
                const error = { ...err, config }

                dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
            })
    }
}

const rSendOTP = (hashCode: any) => {
    return function (dispatch: any) {
        rSendOtp(hashCode)
            .then((response) => {
                dispatch({ type: DeliveryDetailsAction.DELIVERY_OTP_RSEND_SUCCESS, payload: response });
            })
            .catch((error) => {
                //Display error
                dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
            })
    }
}

export { DeliveryDetailsAction, getDeliveryDetails, deliveryCheck, OTPInitiate, OTPValidateApi, rSendOTP };